export default {
  api_r_user_module_inecoRiskManager_getModuleData: {
    path: 'm/ineco-risk-manager/get-module-data/',
  },
  api_r_user_module_inecoRiskManager_getPermissions: {
    path: 'm/ineco-risk-manager/get-permissions/',
  },
  api_r_user_module_inecoRiskManager_generateFilterHexCode: {
    path: 'm/ineco-risk-manager/generate-filter-hex-code/',
  },
  api_r_user_module_inecoRiskManager_getFilters: {
    path: 'm/ineco-risk-manager/get-filters/',
  },
  api_r_user_module_inecoRiskManager_risk_list: {
    path: 'm/ineco-risk-manager/risk/list/',
  },
  api_r_user_module_inecoRiskManager_risk_level: {
    path: 'm/ineco-risk-manager/risk/level/',
  },
  api_r_user_module_inecoRiskManager_risk_add: {
    path: 'm/ineco-risk-manager/risk/add/',
  },
  api_r_user_module_inecoRiskManager_risk_get: {
    path: 'm/ineco-risk-manager/risk/get/',
  },
  api_r_user_module_inecoRiskManager_risk_edit: {
    path: 'm/ineco-risk-manager/risk/edit/',
  },
  api_r_user_module_inecoRiskManager_risk_delete: {
    path: 'm/ineco-risk-manager/risk/delete/',
  },
  api_r_user_module_inecoRiskManager_risk_comment_edit: {
    path: 'm/ineco-risk-manager/risk/comment/edit/',
  },
  api_r_user_module_inecoRiskManager_risk_action_add: {
    path: 'm/ineco-risk-manager/risk/action/add/',
  },
  api_r_user_module_inecoRiskManager_risk_action_edit: {
    path: 'm/ineco-risk-manager/risk/action/edit/',
  },
  api_r_user_module_inecoRiskManager_risk_action_delete: {
    path: 'm/ineco-risk-manager/risk/action/delete/',
  },
  api_r_user_module_inecoRiskManager_risk_intervention_add: {
    path: 'm/ineco-risk-manager/risk/intervention/add/',
  },
  api_r_user_module_inecoRiskManager_risk_intervention_edit: {
    path: 'm/ineco-risk-manager/risk/intervention/edit/',
  },
  api_r_user_module_inecoRiskManager_risk_intervention_delete: {
    path: 'm/ineco-risk-manager/risk/intervention/delete/',
  },
  api_r_user_module_inecoRiskManager_risk_identification_tab: {
    path: 'm/ineco-risk-manager/risk/identification/tab/',
  },
  api_r_user_module_inecoRiskManager_risk_tracking_tab: {
    path: 'm/ineco-risk-manager/risk/tracking/tab/',
  },
  api_r_user_module_inecoRiskManager_risk_milestone_list: {
    path: 'm/ineco-risk-manager/risk/milestone/list/',
  },
  api_r_user_module_inecoRiskManager_risk_xls_export: {
    path: 'm/ineco-risk-manager/risk/milestone/xls/export/',
  },
  api_r_user_module_inecoRiskManager_risk_milestone_download: {
    path: 'm/ineco-risk-manager/risk/milestone/download/',
  }
};
